import styles from './Arrow.module.scss'

export default function Arrow({ direction, current, max, changePage }) {
  const getClasses = () => {
    if (direction === 'previous') {
      return styles.reverse
    }
  }

  /**
   * Trigger "next page" action
   */
  const nextPage = () => {
    if (current + 1 <= max) {
      changePage(current + 1)
    }
  }

  /**
   * Trigger "prev page" action
   */
  const previousPage = () => {
    if (current - 1 > 0) {
      changePage(current - 1)
    }
  }

  /**
   * Decides which onchange action to use.
   */
  const handlePageChange = () => {
    if (direction === 'previous') {
      previousPage()
    } else {
      nextPage()
    }
  }

  const getAlt = () => {
    if (direction === 'next') {
      return 'Seuraava sivu'
    }

    return 'Edellinen sivu'
  }

  return (
    <div className={`${styles.arrow} ${getClasses()}`}>
      <img
        role="button"
        onClick={handlePageChange}
        src="/img/pagination-arrow.svg"
        alt={getAlt()}
        width={50}
        height={50}
        loading="lazy"
      />
    </div>
  )
}
